export default __webpack_public_path__ + "static/media/marrigeg.764c211d.png";